// extracted by mini-css-extract-plugin
module.exports = {"form":"completePass_form__BsIRc"};